"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = TextField;
var _classnames = _interopRequireDefault(require("classnames"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon/Icon"));
require("./styles.scss");
var _utils = require("../../utils");
var _IconTooltip = _interopRequireDefault(require("../IconTooltip"));
function TextField(props) {
  var value = props.value,
    autoFocus = props.autoFocus,
    onChange = props.onChange,
    onBlur = props.onBlur,
    label = props.label,
    disabled = props.disabled,
    iconLeft = props.iconLeft,
    iconRight = props.iconRight,
    id = props.id,
    className = props.className,
    helperText = props.helperText,
    placeholder = props.placeholder,
    errorText = props.errorText,
    warningText = props.warningText,
    readonly = props.readonly,
    display = props.display,
    type = props.type,
    onKeyDown = props.onKeyDown,
    onClickRightIcon = props.onClickRightIcon,
    tooltipTitle = props.tooltipTitle,
    min = props.min,
    max = props.max,
    disabledCharacters = props.disabledCharacters,
    preserveNewlines = props.preserveNewlines;
  var textfieldClass = (0, _classnames.default)({
    'textfield-value': true,
    'textfield-value--disabled': disabled,
    'textfield-value--error': !!errorText,
    'textfield-value--warning': !!warningText,
    'textfield-value--readonly': readonly
  });
  var textfieldOnChange = function textfieldOnChange(event) {
    var textValue = event.target.value;
    if ((0, _utils.isWhitespaces)(textValue)) {
      return;
    }
    if (onChange) {
      onChange(textValue);
    }
  };
  var onKeyDownHandler = function onKeyDownHandler(e) {
    if (disabledCharacters && disabledCharacters.includes(e.key)) {
      e === null || e === void 0 ? void 0 : e.preventDefault();
      return;
    }
    if (onKeyDown) {
      onKeyDown(e.key);
    }
  };
  var renderRightIcon = function renderRightIcon() {
    if (iconRight === 'cancel' && !value) {
      return null;
    }
    return /*#__PURE__*/_react.default.createElement("button", {
      onClick: onClickRightIcon,
      className: "textfield-value--icon-container"
    }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
      name: iconRight,
      className: "textfield-value--icon-right".concat(iconRight === 'cancel' ? '--cancel' : '')
    }));
  };
  var typeProps = {
    type: type
  };
  if (type === 'number') {
    if (min !== undefined) {
      typeProps.min = min;
    }
    if (max !== undefined) {
      typeProps.max = max;
    }
  }
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "textfield ".concat(className)
  }, /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: "textfield-label"
  }, label, tooltipTitle && /*#__PURE__*/_react.default.createElement(_IconTooltip.default, {
    placement: "top",
    title: tooltipTitle
  })), !display && (type === 'text' || type === 'number' ? /*#__PURE__*/_react.default.createElement("div", {
    id: id,
    className: textfieldClass
  }, iconLeft && /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: iconLeft,
    className: "textfield-value--icon-left"
  }), /*#__PURE__*/_react.default.createElement("input", Object.assign({
    autoFocus: autoFocus,
    value: type === 'number' ? value : value || '',
    disabled: readonly || disabled,
    placeholder: placeholder,
    onChange: textfieldOnChange,
    onBlur: onBlur,
    onKeyDown: onKeyDownHandler,
    onWheel: function onWheel(e) {
      return e.currentTarget.blur();
    }
  }, typeProps)), iconRight ? renderRightIcon() : null) : /*#__PURE__*/_react.default.createElement("textarea", {
    autoFocus: autoFocus,
    className: textfieldClass,
    value: value,
    disabled: readonly || disabled,
    placeholder: placeholder,
    onChange: textfieldOnChange,
    onBlur: onBlur
  })), display && /*#__PURE__*/_react.default.createElement("p", {
    className: "textfield-value--display".concat(preserveNewlines ? ' preserve-newlines' : '')
  }, value), errorText && /*#__PURE__*/_react.default.createElement("div", {
    className: "textfield-label-container"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "error",
    className: "textfield-error-text--icon"
  }), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: "textfield-error-text"
  }, errorText)), warningText && /*#__PURE__*/_react.default.createElement("div", {
    className: "textfield-label-container"
  }, /*#__PURE__*/_react.default.createElement(_Icon.default, {
    name: "warning",
    className: "textfield-warning-text--icon"
  }), /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: "textfield-warning-text"
  }, warningText)), helperText && /*#__PURE__*/_react.default.createElement("label", {
    htmlFor: id,
    className: "textfield-help-text"
  }, helperText));
}